/* eslint-disable react/jsx-no-undef */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Steps, Modal, Button, Icon } from 'antd'
import _ from 'lodash'

import PurchaseOrderCreationStep0 from './PurchaseOrderCreationStep0'
import PurchaseOrderCreationStep1 from './PurchaseOrderCreationStep1'
import PurchaseOrderCreationStep2 from './PurchaseOrderCreationStep2'

const propTypes = {
  changeCreateChangeOrderStep: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  modalIsShowing: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleCreate: PropTypes.func.isRequired,
  setSelectedEstimateId: PropTypes.func.isRequired,

  // VendorPurchaseOrderBasicInfo
  basicInfoInputChange: PropTypes.func.isRequired,
  basicInfoDescription: PropTypes.string,
  terms: PropTypes.string,
  shipTo: PropTypes.string,
  attention: PropTypes.string,
  setVendorAdressForm: PropTypes.func.isRequired,

  // PurchaseOrderEditor
  purchaseOrderSections: PropTypes.array,
  purchaseOrderItems: PropTypes.array,
  onSectionNameChange: PropTypes.func.isRequired,
  addSection: PropTypes.func.isRequired,
  allItems: PropTypes.array,
  moveSectionDown: PropTypes.func.isRequired,
  moveSectionUp: PropTypes.func.isRequired,
  moveItemUp: PropTypes.func.isRequired,
  moveItemDown: PropTypes.func.isRequired,
  deleteSection: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  createNewItem: PropTypes.func.isRequired,
  updatePurchaseOrderSections: PropTypes.func.isRequired,
  updatePurchaseOrderItems: PropTypes.func.isRequired
}

const { Step } = Steps

class PurchaseOrderCreationSteps extends Component {
  state = {
    selectedEstimateItems: {}
  }

  handleCreate = () => {
    this.updateSelectedEstimateItems(null)
    this.props.handleCreate()
  }

  handleCancel = () => {
    this.updateSelectedEstimateItems(null)
    this.props.handleCancel()
  }

  updateSelectedEstimateItems = selectedItems => {
    this.setState({
      selectedEstimateItems: selectedItems
    })
  }

  generateFooter = () => {
    const { step, changeCreateChangeOrderStep } = this.props

    switch (step) {
      case 0:
        return null

      case 1:
        return [
          <Button.Group key={1}>
            <Button type="primary" onClick={() => changeCreateChangeOrderStep(0)}>
              <Icon type="left" />
              Previous Step
            </Button>
            <Button type="primary" onClick={() => changeCreateChangeOrderStep(2)}>
              Next Step
              <Icon type="right" />
            </Button>
          </Button.Group>
        ]

      // eslint-disable-next-line no-case-declarations
      default:
        const { selectedEstimateItems } = this.state
        const stepToBack = _.isEmpty(selectedEstimateItems) ? 0 : 1
        return [
          <Button
            key="prev-step"
            type="primary"
            onClick={() => changeCreateChangeOrderStep(stepToBack)}
          >
            <Icon type="left" />
            Previous Step
          </Button>,
          <Button key="back" onClick={this.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleCreate}>
            Create
          </Button>
        ]
    }
  }

  render() {
    const {
      step,
      modalIsShowing,
      handleCancel,
      handleCreate,
      changeCreateChangeOrderStep,
      setSelectedEstimateId
    } = this.props

    const { selectedEstimateItems } = this.state

    return (
      <Modal
        visible={modalIsShowing}
        title="Purchase Order Creation"
        okText={'Add'}
        onCancel={handleCancel}
        onOk={handleCreate}
        width={'90%'}
        footer={this.generateFooter()}
        maskClosable={false}
      >
        <div className="row mt-4">
          <div className="col-12">
            <Steps size="small" current={step}>
              <Step title="Select Estimate" />
              <Step title="Select Estimate Items" />
              <Step title="Create Purchase Order" />
            </Steps>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12">
            {step === 0 && (
              <PurchaseOrderCreationStep0
                changeCreateChangeOrderStep={changeCreateChangeOrderStep}
                updateSelectedEstimateItems={this.updateSelectedEstimateItems}
                setSelectedEstimateId={setSelectedEstimateId}
              />
            )}
            {step === 1 && (
              <PurchaseOrderCreationStep1
                updateSelectedEstimateItems={this.updateSelectedEstimateItems}
                selectedEstimateItems={selectedEstimateItems}
              />
            )}
            {step === 2 && (
              <PurchaseOrderCreationStep2
                selectedEstimateItems={selectedEstimateItems}
                {...this.props}
              />
            )}
          </div>
        </div>
      </Modal>
    )
  }
}

PurchaseOrderCreationSteps.propTypes = propTypes
export default PurchaseOrderCreationSteps



// WEBPACK FOOTER //
// ./src/components/purchaseorders/PurchaseOrderCreationSteps.js